import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

import {
  toggleModal,
  setStep,
  updateGuestBanner
} from '@store/user-review/actions';
import { reviewSteps } from '@constants/review';
import API from '@utils/API';
import Logger from '@utils/Logger';

function useCureLikes(item, likeUrl, removeUrl) {
  const route = useRouter();
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);

  const [isLiked, setLiked] = useState(item.is_liked_by_current_user);
  const [likesCount, setLikesCount] = useState(item.likes_count);

  const handleToggleLike = async () => {
    if (!user) {
      dispatch(setStep(reviewSteps.guestBanner));
      dispatch(updateGuestBanner({ redirectUri: route.asPath }));
      dispatch(toggleModal());
      return;
    }

    try {
      const newLikedFlag = !isLiked;

      if (newLikedFlag) {
        await API.post(likeUrl);
      } else {
        await API.delete(removeUrl);
      }

      setLikesCount(newLikedFlag ? likesCount + 1 : likesCount - 1);
      setLiked(newLikedFlag);
    } catch (e) {
      Logger.error(e);
    }
  };

  return {
    isLiked,
    likesCount,
    handleToggleLike
  };
}

export { useCureLikes };
